<template>
    <div class="epf-filter__buttons" :class="additionalClass">
        <h3 class="epf-filter__buttons__title">{{filterConfig.title}}</h3>
        <div class="epf-filter__buttons__wrap">
            <global-button v-for="option in availableOptions"
                           :key="option.value || option"
                           :theme="isSelectedOption(option) ? 'primary' : 'secondary'"
                           @click="selectOption(option)"
                           v-html="option.title || option.value || option">
            </global-button>
        </div>
        <div class="epf-filter__buttons__footnote"><small v-show="selectedOption.footnote">({{selectedOption.footnote}})</small></div>
    </div>
</template>

<script>
import GlobalButton from '@global/global-elements/global-button/global-button';

export default {
    name: "EpfFilterButtons",
    components: {GlobalButton},
    props: {
        filterConfig: Object,
        additionalClass: ''
    },
    computed: {
        selectedValue() {
            return this.$store.getters.filterValueByName(this.filterConfig.name);
        },
        selectedOption() {
            return this.filterConfig.options.find((option) => {
                return option.value === this.selectedValue;
            })
        },
        availableOptions() {
            return this.filterConfig.options;
        }
    },
    methods: {
        isSelectedOption: function(option) {
            if (option.value) {
                return option.value === this.selectedValue;
            }
            return option === this.selectedValue;
        },
        selectOption: function(option) {
            if (!this.isSelectedOption(option)) {
                this.$store.dispatch('setFilterState', {
                    filterName: this.filterConfig.name,
                    value: option.value || option
                });
            }
        }
    }
}
</script>
